export default {
      id: "icon_appli-usage",
      viewBox: "0 0 30 43",
      url: "../dist/images/" + "sprite.svg#icon_appli-usage",
      toString: function () {
        return this.url;
      }
    }